var _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgLicense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.342,115.223c-4.474-10.571-11.884-19.57-21.424-26.028c-9.789-6.617-21.214-10.112-33.104-10.112H59.186 c-7.994,0-15.744,1.572-23.039,4.657c-10.582,4.478-19.581,11.884-26.032,21.428C3.495,114.972-0.003,126.418,0,138.273v235.454 c0,7.987,1.564,15.738,4.658,23.043c4.474,10.586,11.884,19.584,21.425,26.022c9.792,6.623,21.238,10.126,33.104,10.126h393.627 c7.976,0,15.726-1.572,23.039-4.658c10.578-4.471,19.581-11.891,26.028-21.436c6.624-9.788,10.122-21.234,10.119-33.097V138.273 C512,130.286,510.436,122.535,507.342,115.223z M483.632,373.727c0,4.155-0.814,8.188-2.418,11.985 c-2.332,5.518-6.196,10.211-11.18,13.57c-5.088,3.43-11.044,5.254-17.219,5.261H59.186c-4.158,0-8.191-0.811-11.995-2.418 c-5.508-2.325-10.198-6.193-13.567-11.181c-3.434-5.088-5.253-11.045-5.256-17.216V138.273c0-4.162,0.814-8.202,2.418-11.999 c2.325-5.504,6.19-10.197,11.18-13.57c5.092-3.43,11.044-5.246,17.219-5.246h393.627c4.162,0,8.199,0.811,11.991,2.404 c5.508,2.332,10.201,6.2,13.57,11.181c3.434,5.087,5.253,11.051,5.256,17.23V373.727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.08,261.217c24.834,0,44.963-20.13,44.963-44.96c0-24.837-20.129-44.966-44.963-44.966 c-24.83,0-44.96,20.129-44.96,44.966C84.121,241.088,104.25,261.217,129.08,261.217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.154,268.107c-0.976-0.976-5.411-1.22-6.613-0.488c-9.167,5.655-19.925,8.956-31.46,8.956 c-11.539,0-22.293-3.301-31.458-8.956c-1.209-0.732-5.637-0.488-6.616,0.488c-7.546,7.549-17.496,24.399-19.502,36.427 c-4.938,29.609,26.692,40.302,57.576,40.302c30.886,0,62.512-10.693,57.579-40.302 C184.654,292.506,174.707,275.656,167.154,268.107z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.244,
    y: 180.584,
    width: 202.124,
    height: 22.49
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.244,
    y: 244.087,
    width: 202.124,
    height: 22.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.244,
    y: 307.598,
    width: 125.392,
    height: 22.49
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.2c5197c33ad01c95d4b5ff2d0c0e5e0b.svg";
export { ForwardRef as ReactComponent };